var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, css } from "lit";
import { styleMap } from 'lit/directives/style-map.js';
import { property } from 'lit/decorators.js';
import { customElement, PICBase, PICAction, base64DecoderJSON } from "../Internals";
let PICOverflow = class PICOverflow extends PICBase {
    set isOpen(iOpen) {
        this.open_ = iOpen;
        this.requestUpdate();
    }
    get isOpen() { return this.open_; }
    ;
    constructor() {
        super();
        this.width = '';
        this.overflowItems = [];
        this.open_ = false;
        this.isinput__ = false;
    }
    checkAndConsumeInlineData() {
        let iData = this.getAttribute('datafromprogress');
        if (iData) {
            this.overflowItems = base64DecoderJSON(iData);
            this.requestUpdate();
        }
        this.removeAttribute('datafromprogress');
    }
    connectedCallback() {
        super.connectedCallback();
        this.isPicComp_ = false;
        this.checkAndConsumeInlineData();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    static get styles() {
        const defaultStyle = css `
        :host{
            /* Was rgba(var(--pic-surfaceColorRGB), .87) - that role tracks
               the *card* surface (white light / near-black dark), so in dark
               mode it flipped this icon toward near-black too. The icon
               actually sits on the nav/header surface, which stays dark in
               BOTH themes, so its foreground should too - same reasoning as
               --pic-onNavSurfaceColor on the modal header (PICModal.ts). */
            --icon-color: var(--pic-onNavSurfaceColor, rgba(255, 255, 255, 0.87));
            --icon-bgcolor-hover: var(--pic-whiteOverlayHoverColor);
            --icon-bgcolor-focus: var(--pic-whiteOverlayFocusColor);
        }
        .pic-overflow{
            cursor: pointer;
            width: 24px;
            color: var(--icon-color);
            padding: 10px;
            border-radius: 50%;
            margin-right: 10px;
        }
        .pic-overflow:hover{
            color: #ffffff;
            background-color: var(--icon-bgcolor-hover);
        }
        .pic-overflow:active,
        .pic-overflow:focus{
            color: #ffffff;
            background-color: var(--icon-bgcolor-focus);
        }
        .overflow-icon{
            padding: 0 10px;
        }
        .overflow-container{
            position: absolute;
            z-index: 99;
            top: 56px; /* the height of the header */
            right: 0px;
            min-width: 160px;
            background-color: var(--pic-surfaceColor, rgb(248, 248, 248));
            border: 1px solid var(--pic-outline, rgb(211, 211, 211));
            border-radius: 4px;
        }
        .overflow-container p{
            padding: 12px;
            margin: 0;
        }
        .overflow-container p:hover{
            background-color: var(--pic-primaryHoverColor, #ffffff);
            border-radius: 4px;
        }
        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    handleClick(e, event) {
        let action = new PICAction();
        let optObj = {};
        Object.assign(optObj, { 'type': 'doSubmit' });
        Object.assign(optObj, { 'event': event });
        action.actionOptions = optObj;
        action.triggerEvent(e);
    }
    toggleMenu(e, mode) {
        if (e.target.nodeName === 'P')
            return;
        if (mode === 'close')
            this.isOpen = false;
        if (!mode)
            this.isOpen = !this.isOpen;
        this.requestUpdate();
    }
    getContainerStyle() {
        let styles = [];
        if (this.isOpen) {
            styles.push({ 'display': 'block' });
        }
        else {
            styles.push({ 'display': 'none' });
        }
        if (this.width)
            styles.push({ 'width': this.width });
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    renderItem(item) {
        return html `
            <p
            @click=${(e) => { this.handleClick(e, item.event); }}
            >${item.text}</p>
        `;
    }
    renderMenu() {
        return html `
        <div class="overflow-container pic-body2" style=${styleMap(this.getContainerStyle())}>
            ${this.overflowItems.map((item) => this.renderItem(item))}
        </div>
        `;
    }
    render() {
        return html `
            ${this.renderCSS(true)} 
            <div
                class="pic-overflow"
                tabindex="0"
                @click=${(e) => this.toggleMenu(e, undefined)}
                @blur=${(e) => this.toggleMenu(e, 'close')}>
                <div
                    class="overflow-icon fa fa-solid fa-ellipsis-vertical">
                </div>
                ${this.overflowItems.length > 0 ? this.renderMenu() : ''}
            </div>
        `;
    }
    ;
};
__decorate([
    property()
], PICOverflow.prototype, "width", void 0);
PICOverflow = __decorate([
    customElement('pic-overflow')
], PICOverflow);
export { PICOverflow };
//# sourceMappingURL=PICOverflow.js.map